import React from 'react';

interface ProblemasSectionProps {
  scrollToSection: (id: string) => void;
}

export default function ProblemasSection({ scrollToSection }: ProblemasSectionProps) {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-serif">
            Isso aconteceu com você?
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Se você passou por alguma dessas situações, <strong>você pode ter direito a receber indenização</strong> da companhia aérea.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-14">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:border-teal-400 hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-time-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Atraso Acima de 4 Horas
            </h3>
            <p className="text-gray-600 leading-relaxed mb-5">
              Seu voo atrasou mais de 4 horas? A companhia aérea deve te indenizar por danos morais e materiais.
            </p>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2 cursor-pointer"
            >
              Verificar meu direito
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:border-teal-400 hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-close-circle-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Cancelamento de Voo
            </h3>
            <p className="text-gray-600 leading-relaxed mb-5">
              Voo cancelado sem aviso prévio ou sem alternativa adequada? Você tem direito a compensação financeira.
            </p>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2 cursor-pointer"
            >
              Verificar meu direito
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:border-teal-400 hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-luggage-cart-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Extravio de Bagagem
            </h3>
            <p className="text-gray-600 leading-relaxed mb-5">
              Bagagem perdida, danificada ou atrasada? A companhia deve indenizar pelos prejuízos causados.
            </p>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2 cursor-pointer"
            >
              Verificar meu direito
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:border-teal-400 hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-user-forbid-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Overbooking
            </h3>
            <p className="text-gray-600 leading-relaxed mb-5">
              Foi impedido de embarcar mesmo com passagem confirmada? Isso é overbooking e você tem direito a indenização.
            </p>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2 cursor-pointer"
            >
              Verificar meu direito
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        <div className="bg-gradient-to-r from-teal-50 to-teal-100/50 rounded-2xl p-10 text-center border border-teal-200">
          <p className="text-2xl font-bold text-gray-900 mb-4">
            Não importa há quanto tempo aconteceu
          </p>
          <p className="text-lg text-gray-700 mb-6 max-w-3xl mx-auto">
            Você tem até <strong>5 anos</strong> para entrar com ação de indenização. Mesmo que o problema tenha acontecido há meses ou anos, ainda dá tempo de receber.
          </p>
          <button
            onClick={() => scrollToSection('contato')}
            className="inline-flex items-center gap-3 bg-teal-600 hover:bg-teal-700 text-white px-10 py-5 rounded-full text-lg font-bold uppercase transition-all duration-300 hover:scale-105 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line text-xl"></i>
            Verificar Meu Caso Agora
          </button>
        </div>
      </div>
    </section>
  );
}
